// @flow
import styled from "styled-components";
import { blogWrapperStyles } from "../../../components/Blog/Breadcrumbs";

const Blockquote = styled.blockquote`
  font-size: 32px;
  line-height: 44px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.hague};
  max-width: 590px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
`;

type Props = {
  quote: string,
};

const Quote = ({ quote }: Props) => (
  <div css={blogWrapperStyles}>
    <Blockquote>“{quote}”</Blockquote>
  </div>
);

export { Quote };
